export default __webpack_public_path__ + "static/media/scholar_3.ff5c2595.jpg";